// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"760":"83a8551d0fc5c789","888":"21030b068c9c5b6a"}[chunkId] + ".css";
};